// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.byhmjQuqGzx2lE {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 40px);
  padding-bottom: 32px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerContainer": `byhmjQuqGzx2lE`
};
export default ___CSS_LOADER_EXPORT___;
